import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { openWhatsApp, defaultWhatsappMessage } from "@/lib/nc";

// Single floating WhatsApp button.
// Auto-hides while the user is viewing the hero action buttons,
// the estimate form, the contact section, or the footer, so it never
// covers those interactive areas.
export const WhatsAppFloat = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const selectors = ["#hero-actions", "#estimate", "#contact", "footer"];
    const targets = selectors
      .map((s) => document.querySelector(s))
      .filter(Boolean);

    if (targets.length === 0) return undefined;

    const visible = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        setHidden(visible.size > 0);
      },
      { threshold: 0.12 }
    );

    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, []);

  return (
    <button
      type="button"
      onClick={() => openWhatsApp(defaultWhatsappMessage)}
      aria-label="Chat with NC on WhatsApp"
      aria-hidden={hidden}
      tabIndex={hidden ? -1 : 0}
      data-testid="whatsapp-float"
      className={`fixed bottom-5 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-whatsapp-foreground shadow-elegant transition-[opacity,transform] duration-300 hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${
        hidden ? "pointer-events-none translate-y-6 opacity-0" : "opacity-100"
      }`}
    >
      <MessageCircle className="h-7 w-7" />
      {!hidden && (
        <span
          className="absolute inline-flex h-full w-full animate-ping rounded-full bg-whatsapp/40"
          aria-hidden="true"
        />
      )}
    </button>
  );
};
